var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_915_5492)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.9996,
    cy: 59.4,
    r: 59.4,
    fill: "#FFE4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1392 51.4801C54.4198 51.4801 57.0792 47.9342 57.0792 43.5601C57.0792 39.186 54.4198 35.6401 51.1392 35.6401C47.8586 35.6401 45.1992 39.186 45.1992 43.5601C45.1992 47.9342 47.8586 51.4801 51.1392 51.4801Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8209 43.5602C86.1014 43.5602 88.7609 40.0143 88.7609 35.6402C88.7609 31.2661 86.1014 27.7202 82.8209 27.7202C79.5403 27.7202 76.8809 31.2661 76.8809 35.6402C76.8809 40.0143 79.5403 43.5602 82.8209 43.5602Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9996 0C32.2465 0 5.59961 26.6468 5.59961 59.4C5.59961 85.3162 22.2896 107.395 45.4806 115.489C46.0288 115.708 46.5832 115.896 47.1448 116.053C52.7831 117.835 58.7803 118.8 64.9996 118.8C97.7528 118.8 124.4 92.1532 124.4 59.4C124.4 26.6468 97.7528 0 64.9996 0ZM43.5348 103.157L42.706 100.898C40.9219 96.0326 40.2851 90.7404 40.8646 85.5925L40.9697 84.6631L36.5565 72.6317C36.1923 71.6385 36.2368 70.5634 36.6815 69.6037C37.1256 68.644 37.9177 67.9144 38.911 67.5502C39.3557 67.3872 39.8165 67.3059 40.2761 67.3059C40.8433 67.3059 41.4086 67.4297 41.9384 67.6752C42.8982 68.1199 43.6278 68.9114 43.9919 69.9047L45.825 74.8998C46.7918 77.5379 48.7286 79.6417 51.2783 80.8224C53.8275 82.0038 56.6847 82.1212 59.3222 81.1537L88.4833 70.4571C89.5089 70.0839 90.6483 70.6098 91.0241 71.634C91.4005 72.6595 90.872 73.799 89.8472 74.1754L82.6439 76.8174C80.0994 77.7506 78.0704 79.6192 76.9308 82.0787C75.7913 84.5381 75.6785 87.2936 76.6118 89.8388L76.9952 90.8842C77.7803 93.0254 77.6849 95.3444 76.7265 97.414C75.7674 99.4837 74.0608 101.056 71.9189 101.841L54.4921 108.234C52.8572 108.832 51.1558 108.896 49.5777 108.518C49.0871 108.363 48.6043 108.192 48.1201 108.024C46.0666 107.121 44.3664 105.423 43.5348 103.157ZM71.3973 110.468L74.6463 109.276C78.7739 107.762 82.0642 104.732 83.912 100.743C85.7606 96.7538 85.9443 92.284 84.4303 88.1563L84.0468 87.1109C83.8418 86.5521 83.867 85.9476 84.117 85.4074C84.3672 84.868 84.8125 84.4574 85.3713 84.2524L92.5745 81.6105C97.6985 79.731 100.339 74.0327 98.4598 68.9068C96.5797 63.7828 90.882 61.1421 85.7561 63.0216L56.5942 73.7182C55.9432 73.9579 55.2369 73.9277 54.6071 73.6363C53.9773 73.3444 53.4991 72.8249 53.2601 72.1726L51.427 67.1768C49.1718 61.0273 42.3359 57.8563 36.1832 60.1147C33.2042 61.2071 30.8285 63.3947 29.4949 66.2744C28.1608 69.1536 28.028 72.3801 29.1211 75.3591L32.8987 85.6586C32.4496 90.7107 32.9542 95.8484 34.3435 100.729C21.7165 91.3386 13.5196 76.3097 13.5196 59.4C13.5196 31.0135 36.6131 7.92 64.9996 7.92C93.3861 7.92 116.48 31.0135 116.48 59.4C116.48 85.6188 96.7735 107.307 71.3973 110.468Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3318 27.9228L46.4518 23.9628C44.3752 23.268 42.1334 24.3928 41.4425 26.4675C40.751 28.5423 41.8724 30.7853 43.9472 31.4768L55.8272 35.4368C56.2429 35.5754 56.6652 35.6411 57.0802 35.6411C58.738 35.6411 60.2835 34.5912 60.8365 32.9322C61.528 30.8575 60.4066 28.6144 58.3318 27.9228Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1192 20.9601C68.5723 22.5063 68.5723 25.0135 70.1192 26.5598C71.6648 28.1067 74.1733 28.1067 75.7189 26.5598C78.5431 23.7367 83.1349 23.7367 85.9592 26.5598C86.732 27.3332 87.7458 27.7199 88.759 27.7199C89.7723 27.7199 90.786 27.3332 91.5589 26.5598C93.1058 25.0135 93.1058 22.5063 91.5589 20.9601C85.6486 15.0485 76.0295 15.0485 70.1192 20.9601Z",
    fill: "#514C9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8799 51.5981L64.0399 55.5581C61.9182 56.0886 60.6277 58.2387 61.1582 60.3605C61.6081 62.16 63.2227 63.3607 64.9971 63.3607C65.3154 63.3607 65.6383 63.3227 65.9607 63.2422L81.8007 59.2822C83.9224 58.7517 85.2129 56.6015 84.6823 54.4797C84.1518 52.3573 81.9991 51.0695 79.8799 51.5981Z",
    fill: "#514C9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_915_5492",
    x: 0.319609,
    y: 0,
    width: 124.081,
    height: 124.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5.28,
    dy: 5.28
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.298039 0 0 0 0 0.623529 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_915_5492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_915_5492",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group (4).ef859d84a7c260f9bbb0612dbe111109.svg";
export { ForwardRef as ReactComponent };